import {
  ModalBuilder,
  Table,
  notifySuccess,
  ActionMenu,
} from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { rejectDeal } from "./actions";
import { DropdownItem } from "semantic-ui-react";

const RejectDeal = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const dispatch = useDispatch();
  const { sheetId, sheetName, availableActionsPrincipal, availableActionsIps } =
    sheet;

  if (
    (process.env.TRADE_AS_IPS && !availableActionsIps.canRejectDeal) ||
    (!process.env.TRADE_AS_IPS && !availableActionsPrincipal.canRejectDeal)
  ) {
    return;
  }

  return (
    <ModalBuilder
      submitAction={rejectDeal}
      submitParams={{ sheetId }}
      onSubmitted={() => {
        dispatch(notifySuccess("Sheet successfully submitted"));
        onSubmitted();
      }}
      renderTrigger={(onTrigger) => (
        <DropdownItem onClick={onTrigger}>
          {t("SheetActions.RejectDeal.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("SheetActions.RejectDeal.ModalHeader")}
          content={t("SheetActions.RejectDeal.ModalContent", { sheetName })}
        />
      )}
    />
  );
};

export default RejectDeal;
